export interface SessionReminderFrame {
    type: 'session_reminder';
    schema: 'ft.session-reminder.v1';
    campaign_id: string;
    campaign_name: string;
    campaign_session_id: string;
    start_utc: string;
    url: string;
}

export function readFrame(value: unknown): SessionReminderFrame | null {
    if (!value || typeof value !== 'object') return null;
    const frame = value as Record<string, unknown>;
    if (frame.type !== 'session_reminder' || frame.schema !== 'ft.session-reminder.v1') return null;
    for (const key of ['campaign_id', 'campaign_name', 'campaign_session_id', 'start_utc', 'url']) {
        if (typeof frame[key] !== 'string' || !frame[key]) return null;
    }
    if (!Number.isFinite(Date.parse(frame.start_utc as string)) || !(frame.start_utc as string).endsWith('Z')) return null;
    try {
        const url = new URL(frame.url as string, location.href);
        if (url.origin !== location.origin || !['https:', 'http:'].includes(url.protocol) || url.username || url.password) return null;
        return { ...frame, url: url.href } as unknown as SessionReminderFrame;
    } catch { return null; }
}

export function reminderTime(frame: SessionReminderFrame): string {
    const minutes = (Date.parse(frame.start_utc) - Date.now()) / 60000;
    return minutes > 0 ? `Starts in ${Math.ceil(minutes)} min` : `Started ${Math.floor(-minutes)} min ago`;
}
